import { useSelector } from 'core/common/hooks';
import { getIsMobileDevice, getUtmSource } from 'core/common/store';

export const useSystem = () => {
  const isMobileDevice = useSelector(getIsMobileDevice);
  const utmSource = useSelector(getUtmSource);

  return { isMobileDevice, utmSource };
};
